export enum SortOptionsCode {
  newest = 'newest',
  oldest = 'oldest'
}



// WEBPACK FOOTER //
// ./src/components/TaskManagement/TaskPreview/Comments/domain/enums.ts